import axios from "axios";
import {RSO_SWITCH_ENDPOINT} from "./useRsoSwitch";

// Admin → RSO → "Clear all RSO data", test environments only. NANCY decides from its own API host
// (never live.api.s10drd.com) and the account's manage permission; this page only shows what it says.
//   GET  Dashboard/api/RsoSwitch/test-data                    -> {allowed, canManage, counts}
//   POST Dashboard/api/RsoSwitch/test-data/clear {confirm}   -> {cleared, clearedOnUtc}
export const RSO_TEST_DATA_ENDPOINT = `${RSO_SWITCH_ENDPOINT}/test-data`;
export const CLEAR_CONFIRMATION = "CLEAR";

const isRecord = (value) => value !== null && typeof value === "object" && !Array.isArray(value);
const COUNT_KEYS = ["materialChanges", "forecastSends", "drafts", "materialSettings", "totalRows"];
export const normalizeCounts = (data) => isRecord(data) && COUNT_KEYS.every((key) => Number.isSafeInteger(data[key]) && data[key] >= 0)
  ? Object.fromEntries(COUNT_KEYS.map((key) => [key, data[key]])) : null;

const headers = (token) => ({Authorization: `Bearer ${token}`});
export const readRsoTestData = async (token) => {
  const {data} = await axios.get(RSO_TEST_DATA_ENDPOINT, {headers: headers(token), timeout: 30000});
  if (!isRecord(data)) throw new Error("Invalid RSO test data");
  const allowed = data.allowed === true && data.canManage === true;
  const counts = normalizeCounts(data.counts);
  return {allowed: allowed && !!counts, counts};
};
export const clearRsoTestData = async (token) => {
  const {data} = await axios.post(`${RSO_TEST_DATA_ENDPOINT}/clear`, {confirm: CLEAR_CONFIRMATION},
    {headers: headers(token), timeout: 120000});
  const cleared = normalizeCounts(data?.cleared);
  if (!cleared) throw new Error("Clear was not confirmed");
  return cleared;
};

const plural = (count, one, many) => `${count.toLocaleString()} ${count === 1 ? one : many}`;
// "4 material changes, 5 monthly sends, 1 draft and 26 saved floor-plan materials"
export const countsText = (counts) => {
  const parts = [plural(counts.materialChanges, "material change", "material changes"),
    plural(counts.forecastSends, "monthly send", "monthly sends"), plural(counts.drafts, "draft", "drafts"),
    plural(counts.materialSettings, "saved floor-plan material", "saved floor-plan materials")];
  return `${parts.slice(0, -1).join(", ")} and ${parts[parts.length - 1]}`;
};
